module.exports = __webpack_public_path__ + "static/media/um.f4540fe0.svg";